import { render } from "./enterprise-details-title.vue?vue&type=template&id=130678b6&scoped=true"
import script from "./enterprise-details-title.vue?vue&type=script&lang=js"
export * from "./enterprise-details-title.vue?vue&type=script&lang=js"

import "./enterprise-details-title.vue?vue&type=style&index=0&id=130678b6&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130678b6"]])

export default __exports__